export const RUM_CDN_URL =
  'https://static.wirkaufendeinauto.de/fesre/management/elastic-apm-rum-15-12-0.umd.min.js';
